module.exports = __webpack_public_path__ + "static/ICONFOOTER-09-ac4cbf2fbabfd9fb0abb5067eebac536.png";